import axios from "axios";
import store from "@/store";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { removeAPIPrefix } from "../../utils/url";

let materialsServiceInstance = null
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_ARANDU_MATERIALS_URL)
export const baseUrl = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_ARANDU_MATERIALS_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_MATERIALS_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!materialsServiceInstance && reverbSecretKey && addressAPIWithoutPrefix && subdomain)
const materialsServiceReverb = () => materialsServiceInstance

const resetMaterialsServiceReverb = () => {
  if (materialsServiceInstance) {
    materialsServiceInstance.disconnect();

    if (materialsServiceInstance.connector?.socket) {
      materialsServiceInstance.connector.socket.close();
    }

    materialsServiceInstance = null
  }
}


const initializeMaterialsServiceReverb = (userToken) => {
  if (shouldInitializeReverb && userToken) {
    
    const reverbWsConnection = () => {
      if (process?.env?.VUE_APP !== 'localhost') {
        return `${subdomain}.${addressAPIWithoutPrefix}`
    }
    return 'localhost'  
    }

    try {
      materialsServiceInstance = new Echo({
        broadcaster: 'reverb',
          key: reverbSecretKey,
          wsHost: reverbWsConnection(),
          wsPort: process?.env?.VUE_APP === 'localhost' ? 6002: 80,
          wssPort: process?.env?.VUE_APP === 'localhost' ? 6002 : 443,
          forceTLS: window.location.protocol === 'https:',
          wsPath: process?.env?.VUE_APP === 'localhost' ? '' : '/materials-app',
          enabledTransports: ['ws', 'wss'],
          authEndpoint: `${reverbBaseURL}/materials-api/broadcasting/auth`,
          auth: {
              headers: {
                  Authorization: 'Bearer ' + userToken,
              },
          }
      })
    } catch(error) {
      console.error(error)
    }
  }
}

const leaveMaterialsServiceReverbPrivateChannel = (channelName) => {
  if (channelName && materialsServiceInstance) {
    materialsServiceInstance.leave(`private-${channelName}`)
  }
}

const MaterialsApiService = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

MaterialsApiService.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  
  (error) => {
    return Promise.reject(error);
  }
);

export {
  resetMaterialsServiceReverb,
  leaveMaterialsServiceReverbPrivateChannel, 
  initializeMaterialsServiceReverb,
  materialsServiceReverb
}

export default MaterialsApiService;


